import { Mark, mergeAttributes } from '@tiptap/core';
import { EDITED_SINCE_PUBLISH_MARK } from '@duke-hq/shared-constants/translationSegmentExtract';

// Render-only mark for the partial translation preview: renders a washed <mark>
// (styled by class in useEditorStyles) on segments the overlay left in English.
// Inert on purpose (no input rules, shortcuts, or paste handling) so it never
// enters the authoring surfaces, even though every editor registers it.
export const EditedSincePublishMark = Mark.create({
  name: EDITED_SINCE_PUBLISH_MARK,

  parseHTML() {
    return [{ tag: 'mark.duke-edited-since-publish' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['mark', mergeAttributes(HTMLAttributes, { class: 'duke-edited-since-publish' }), 0];
  },
});
